import React from 'react';
import { BiLoaderAlt } from 'react-icons/bi';
import s from './SpinnerMini.module.scss';

const SpinnerMini = () => <BiLoaderAlt className={s.spinnerMini} />;

export default SpinnerMini;
